exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n._title_0[data-v-043e71d1] {\r\n  text-align: center;\r\n  border: 1px solid #ebeef5;\r\n  border-bottom-width: 0;\r\n  margin: 10px 0 0 0;\r\n  padding: 12px;\r\n  background-color: #e7ecf025;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-043e71d1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/DashboardTicketTable.vue
// module id = 759
// module chunks = 75